
const parameters = {

    // false true

    app: {
        release:                    'A1|1',
        domain:                     'visualize.abstraktion.io',
        production:                 false,
        debug:                      !true, //false
        model: {
            create:                     true,   // create new models
            modify:                     true   // modify grids
        },
        material: {
            create:                     true,
            sizes: [
                256 , 512 , 1024 , 4096
            ]
        }
    },

    scene: {

        three_dimension:            false,                   // rotation z

        model: {

            grid: {
                display:            !false,
                color:              0x00ff00,
                colors:             [
                    0xb71c1c , 0xE65100 , 0x757575 , 0x1565C0 , 0x00838F , 0x2E7D32 , 0x283593 , 0x0277BD , 0x00695C , 0x2E7D32 ,
                    0x558B2F , 0x9E9D24 , 0xF9A825 , 0xFF8F00 , 0xEF6C00 , 0xD84315 , 0x4E342E , 0x424242
                ]
            },

            dot: {
                display:            true,
                color:              0xffff00,
                size:               5,
                three_dimension:    true,                  // z axis
            }

        }

    }

}

export default parameters